<twc-list class="height-100">
    <twc-list-item *ngFor="let item of list"
        [ngClass]="{'selected-row': item.id === selectedItem && isSelectionEnabled}" (click)="onSelect(item.id)">
        <div class="twc-list-item-col-2 twc-body description">
            {{item.name | translate}}
        </div>
        <div class="twc-list-item-col-3 buttons-container"
            [ngClass]="{'read-only': isReadOnly, 'switch': iconsType==='switch'}" [ngSwitch]="iconsType">
            <ng-container *ngSwitchCase="'switch'">
                <twc-icon *ngFor="let actionIcon of item.iconsAction" [shape]="actionIcon.icon" [size]="32"
                    class="twc-ml-3" [ngClass]="{'icon-inactive': actionIcon.status === 'inactive', 
                    'icon-forced': actionIcon.status === 'forced',
                    'icon-deny-forced': actionIcon.status === 'deny-forced',
                    'icon-disabled': actionIcon.isDisabled}"
                    [twcTooltip]="actionIcon.tooltip ? (actionIcon.tooltip | translate) : ''"
                    (click)="onActionClick(item.id, actionIcon)" placement="bottom"></twc-icon>
            </ng-container>

            <ng-container *ngSwitchCase="'button'">
                <button *ngFor="let actionIcon of item.iconsAction"
                    [twcTooltip]="actionIcon.tooltip ? (actionIcon.tooltip | translate) : ''"
                    [disabled]="actionIcon.isDisabled"
                    class="twc-button twc-button-secondary twc-button-icon twc-button-s twc-mr-1"
                    (click)="onActionClick(item.id, actionIcon)" placement="bottom">
                    <twc-icon [shape]="actionIcon.icon" [size]="24"></twc-icon>
                </button>
            </ng-container>

        </div>
    </twc-list-item>
</twc-list>